import { AfterViewInit, ChangeDetectorRef, Component, HostListener } from '@angular/core'
import { Title, Meta } from '@angular/platform-browser'
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-insured',
  templateUrl: 'insured.component.html',
  styleUrls: ['insured.component.css'],
})
export class InsuredComponent {
  // parallaxOffset = 0;
  bannerImageTop =  window.screen.width < 1440 && window.screen.width > 1024 ? '14%' : '25%';
  screenWidth: number;
  activeTab: string = 'contactIdIsured'; // Default active tab

  scrollY = 0;
  ballPinkOffset = 0;
  bonePurppleOffset = 0;
  eiffelWhiteOffset = 0;
  luggagePurppleOffset = 0;
  pillSilverRightOffset = 0;
  sphereSilverOffset = 0;

  constructor(private cdr: ChangeDetectorRef, private route: ActivatedRoute) {
    this.getScreenSize();
  }

  ngOnInit() {
   
    this.route.queryParamMap.subscribe(params => {
      const query = params.get('activeTab');
      console.log(query);
      if(query)
      this.setActiveTab(query);
    });

    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY;
      const percentStart = window.screen.width < 1440 && window.screen.width > 1024 ? 14 : 25;
      
      if(window.scrollY > 0 && window.scrollY < 400) {
        if (scrollPosition > 0 && scrollPosition < 400) {
          const percent = percentStart + (scrollPosition / 400) * 6; // Ajuste de 14% a 20%
          this.bannerImageTop = `${percent}%`;
        }
      }
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const speed = 1;
    const min = 30;
    const max = 70;
    const delay = 15;
    const currentY = window.scrollY;
    const direction = currentY - this.scrollY;

    const ballPink = document.querySelector('.banner-image-separate img.parallax-image#Ball-Pink') as HTMLElement;
    const bonePurpple = document.querySelector('.banner-image-separate img.parallax-image#Bone-Purpple') as HTMLElement;
    const eiffelWhite = document.querySelector('.banner-image-separate img.parallax-image#Eiffel-White') as HTMLElement;
    const luggagePurpple = document.querySelector('.banner-image-separate img.parallax-image#Luggage-purpple') as HTMLElement;
    const pillSilverRight = document.querySelector('.banner-image-separate img.parallax-image#Pill-Silver-Right') as HTMLElement;
    const sphereSilver = document.querySelector('.banner-image-separate img.parallax-image#Sphere-Silver') as HTMLElement;

    if (ballPink) {
      this.ballPinkOffset += direction > 0 ? -speed : speed;

      this.ballPinkOffset = Math.max(-max, Math.min(min, this.ballPinkOffset));

      ballPink.style.transform = `translateY(${this.ballPinkOffset}px)`;
    }

    if(this.ballPinkOffset < -delay && pillSilverRight){
      this.pillSilverRightOffset += direction > 0 ? -speed : speed;

      this.pillSilverRightOffset = Math.max(-max, Math.min(min, this.pillSilverRightOffset));

      pillSilverRight.style.transform = `translateY(${this.pillSilverRightOffset}px)`;
    }

    if(this.pillSilverRightOffset < -delay && luggagePurpple){
      this.luggagePurppleOffset += direction > 0 ? -speed : speed;

      this.luggagePurppleOffset = Math.max(-max, Math.min(min, this.luggagePurppleOffset));

      luggagePurpple.style.transform = `translateY(${this.luggagePurppleOffset}px)`;
    }
    
    if(this.luggagePurppleOffset < -delay && bonePurpple){
      this.bonePurppleOffset += direction > 0 ? -speed : speed;

      this.bonePurppleOffset = Math.max(-max, Math.min(min, this.bonePurppleOffset));

      bonePurpple.style.transform = `translateY(${this.bonePurppleOffset}px)`;
    }

    if(this.bonePurppleOffset < -delay && eiffelWhite){
      this.eiffelWhiteOffset += direction > 0 ? -speed : speed;

      this.eiffelWhiteOffset = Math.max(-max, Math.min(min, this.eiffelWhiteOffset));

      eiffelWhite.style.transform = `translateY(${this.eiffelWhiteOffset}px)`;
    }
    
    if(this.eiffelWhiteOffset < -delay && sphereSilver){
      this.sphereSilverOffset += direction > 0 ? -speed : speed;

      this.sphereSilverOffset = Math.max(-max, Math.min(min, this.sphereSilverOffset));

      sphereSilver.style.transform = `translateY(${this.sphereSilverOffset}px)`;
    }

    if(currentY <= 0){
      ballPink.style.transform = 'none';
      bonePurpple.style.transform = 'none';
      eiffelWhite.style.transform = 'none';
      luggagePurpple.style.transform = 'none';
      pillSilverRight.style.transform = 'none';
      sphereSilver.style.transform = 'none';
      this.ballPinkOffset = 0;
      this.bonePurppleOffset = 0;
      this.eiffelWhiteOffset = 0;
      this.luggagePurppleOffset = 0;
      this.pillSilverRightOffset = 0;
      this.sphereSilverOffset = 0;
    }

    this.scrollY = currentY;
  }

  // @HostListener('window:resize', ['$event'])
  // @HostListener('window:scroll', [])

  getScreenSize(event?) {
    setTimeout(() => {
      this.screenWidth = screen.width;
      this.cdr.detectChanges(); // Detect changes manually
    });
  }

  // onWindowScroll() {
  //   const scrollPosition = window.scrollY;
  //   this.parallaxOffset = scrollPosition * 0.5; // Adjust speed
  //   console.log('scrollPosition', scrollPosition)
  // }


  setActiveTab(tabId: string) {
    this.activeTab = tabId;
    this.scrollTo(tabId);
  }

  scrollTo(elementId: string): void {
    setTimeout(() => {
      const element = document.getElementById(elementId);
      if (element) {
        const headerOffset = window.innerWidth >= 992 ? 165 : 230; // header fijo (81) + barra de pestanas fija (~64) + aire

        if (element) {
          const elementPosition = element.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });

        }
      }
    }, 100);
  }

}
